import styled from 'styled-components';

export default styled.div`
  display: flex;
  border-bottom: 1px solid rgb(225, 227, 244);
  padding: 0.75rem;
  min-height: 4.5rem;
  line-height: 4.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background: ${props => props.dropdownBackgroundColor ? props.dropdownBackgroundColor : 'rgb(255, 255, 255)'};
  font-family: ${props => props.titleAsFont ? props.titleAsFont : 'inherit'};

  &:hover {
    background: ${props => props.dropdownHoverBackgroundColor ? props.dropdownHoverBackgroundColor : props.dropdownBackgroundColor || 'rgba(247, 248, 253, 1)'};
  }

  &:last-child {
    border-bottom: none;
  }

  ${props => props.thisStyles}
`;
